/** Wording for the idea-validation wizard — written for a founder, not an analyst. */
export const ideaValidationCopy = {
  title: 'Validate your idea',
  subtitle:
    'Describe what you want to build. Vibelin then walks you through the validation stages, one generated document at a time.',
  idea: {
    heading: 'What are you building?',
    helper:
      'Explain it the way you would to a co-founder: the problem, who has it, and how your product solves it. Markdown works. Pick Web Application or Mobile App for a structure to fill in, or Blank to start from scratch.',
    label: 'Your idea',
    placeholder: [
      '## The problem',
      'Independent gyms still manage class bookings over WhatsApp and lose members when slots fill up.',
      '',
      '## The idea',
      'A booking app a gym owner sets up in ten minutes, with waitlists and payments built in.',
      '',
      '## Who it is for',
      'Owners of single-location gyms and studios with 100–500 members.',
    ].join('\n'),
  },
  kind: {
    label: 'What kind of product?',
    replaceMessage: 'Switching the template replaces what you have written so far.',
    clearMessage: 'Starting blank clears what you have written so far.',
  },
  fromWebsite: {
    heading: 'Already have a website?',
    helper:
      'Paste it and we draft the description from what is online, in the Web Application or Mobile App structure if you picked one. You review and edit it before moving on.',
    urlLabel: 'Website',
    button: 'Draft from website',
    generating: 'Reading your website and drafting the description. This can take a minute…',
    done: 'Draft ready. Read it through and make it yours before continuing.',
    sourcesLabel: 'Based on:',
    replaceMessage: 'The draft from your website will replace what you have written so far.',
  },
  start: 'Start validation',
  startHint:
    'Creates the project, named from your website or your idea, and generates the first stage, Problem & Pain. You follow the progress on the next screen.',
} as const;
